<igx-simple-combo [data]="templates" displayKey="name" [(ngModel)]="template"></igx-simple-combo>
<form (ngSubmit)="submit()" [formGroup]="form" style="display: contents;">
    <igx-input-group>
        <label igxLabel>До</label>
        <input igxInput formControlName="receiver" type="email"/>
    </igx-input-group>
    <igx-input-group>
        <label igxLabel>Тема</label>
        <input igxInput formControlName="subject"/>
    </igx-input-group>
    <div class="NgxEditor__Wrapper">
        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
        <ngx-editor class="data" [editor]="editor" formControlName="data"></ngx-editor>
    </div>
    <div class="buttons">
        <button type="button" igxButton="contained" (click)="done.emit()">Откажи</button>
        <button igxButton="contained">Изпрати</button>
    </div>
</form>
